var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.657,
    height: 25,
    viewBox: "0 0 25.657 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#662d91;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M517.852-542.647v2.936a9.971,9.971,0,0,1,6.711,12.4,9.97,9.97,0,0,1-6.711,6.711v2.95a12.82,12.82,0,0,0,9.657-15.344,12.822,12.822,0,0,0-9.657-9.656m3.563,12.5a6.364,6.364,0,0,0-3.563-5.744v11.444a6.27,6.27,0,0,0,3.563-5.7m-19.241-4.276v8.552h5.7L515-518.745v-22.8l-7.126,7.126Z",
    transform: "translate(-502.174 542.647)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSound);
export default __webpack_public_path__ + "static/media/icon_sound.79ba51be894bd04ba169b3e5b80e65a1.svg";
export { ForwardRef as ReactComponent };